import React from 'react';
import { Container } from 'react-bootstrap';
import './AboutPage.css'

function AboutPage(props) {
    return (
        <Container fluid className="p-about">
            <div className="p-about-bg-img">
                {/* <h1 className="about-title">אודות המפתח הביבליוגרפי:</h1> */}
                <div className="about-text">
                    <p>מפתח השירים הבסיסי הינו תוצר יוזמה פרטית של הגברת קרניה דן, מי שהיתה ראש ענף עברית/ערבית בספריית אוניברסיטת חיפה עד לפרישתה לגמלאות.</p>
                    <p>המפתח בגרסתו הביתית נתרם על ידי הגברת לספריית אוניברסיטת חיפה, במטרה להעמידו לשימוש קהילת האוניברסיטה והקהל הרחב כאחד. </p>
                    <p>ב"מילחן" - ממופתחים למעלה מ - 700 פרסומים (שירונים, ספרים, חוברות) שפורסמו החל בשנות ה-30 ועד היום והוא מכיל למעלה מ- 30000 ערכים.</p>
                    <p>ב"מילחן" ניתן לחפש לפי: שם שיר, שלוש המילים הראשונות בשיר, שמות היוצרים, נושאים בולטים בתוכן השיר ושם הפרסום שבתוכו הופיע (הספר או השירון).</p>
                    <p>פרסומים הממופתחים ב"מילחן" והנמצאים בספריית אוניברסיטת חיפה מקושרים לקטלוג הספריה ישירות מדף תוצאות החיפוש של המאגר.</p>
                </div>
                {/* <div className="about-img"></div> */}
            </div>
        </Container>
    );
}

export default AboutPage;